import Vuetify from '../plugins/vuetify'

export const defineTableHeader = (text, value, icon = null, sortable = true, align = 'left', options = {}) => ({
  text: Vuetify.framework.lang.t(text),
  value,
  icon,
  align,
  sortable,
  ...options
})

export const defineTableCustomTextHeader = (text, value, icon = null, sortable = true, align = 'left', options = {}) => {
  const buffer = defineTableHeader('', value, icon, sortable, align, options)
  buffer.text = text // customed text

  return buffer
}
